<template>
  <footer>
    <div class="container">
      <div class="contact">
        <div class="contact-qrcode">
          <img src="@/assets/images/chuang-min.jpg" alt="">
          <p>供应链旗下品牌</p>
        </div>
        <div class="contact-others">
          <p>商务合作：18105739159</p>
          <p>联系邮箱：cmcmus@icloud.com</p>
        </div>
      </div>
      <div class="copyright">© 2025. All rights reserved. 卡妙科技 <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备20018411号</a></div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
footer{
  background: #373D44;
  color: #fff;
  .contact {
    padding: 60px 0 30px;
    &-qrcode {
      padding-bottom: 30px;
      img {
        width: 140px;
        height: 140px;
        display: block;
        margin: 0 auto;
      }
      p {
        padding-top: 10px;
        text-align: center;
        font-size: 16px;
      }
    }
    &-others {
      p {
        text-align: center;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
  .copyright {
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    a{
      color: #fff;
      display: inline-block;
      margin-left: 10px;
    }
  }
}
@media screen and (min-width: 768px) {
  footer {
    .contact {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 90px 0 60px;
      &-qrcode {
        padding-right: 90px;
        position: relative;
        border-right: 1px solid rgba(255,255,255,.1);
        p {
          font-size: 20px;
        }
      }
      &-others {
        padding-left: 90px;
        p {
          text-align: left;
          font-size: 20px;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
